// extracted by mini-css-extract-plugin
export var closeButton = "_lh-1";
export var closeX = "_lh-3";
export var container = "_lh-0";
export var image = "_lh-2";